export default "__VITE_ASSET__DtgRLYtf__"